import Engine from "./Engine";

class cfJSClass {
    /*
    * return element by id
    */
    byId(id) {
        return document.getElementById(id);
    }
    /*
    * get widget by id
    */
    getWidgetById(id){
        return Engine.widgetsList.get(id);
    }
    /*
    * return first element by name
    */
    byName(name) {
        return document.getElementsByName(name)[0];
    }
    /*
    * style set function
    */
    style(dom, styles, value) {
        try {
            if (dom && styles && !value)
                if (typeof styles === "string") {
                    return dom.style[styles]
                } else {
                    for (let i in styles)
                        dom.style[i] = styles[i];
                }

            if (dom && styles && value)
                dom.style[styles] = value;
        } catch (e) {
            console.log("Error Engine.style: " + e);
        }
    }
    /*
    * search first element
    */
    querySelector(dom,selector) {
        if (String(selector).substr(0,1)==">") {
            let isBeId = false;
            if (!dom.id)
                dom.id = "selector_id_fixed";
            else
                isBeId = true;

            let result = dom.querySelector("#"+dom.id+selector);

            if (!isBeId)
                dom.removeAttribute("id");

            return result;
        } else
            return dom.querySelector(selector);
    }
    /*
    * Get elements (array) from page by query
    */
    querySelectorAll(dom,selector) {
        if (String(selector).substr(0,1)==">") {
            let isBeId = false;
            if (!dom.id)
                dom.id = "selector_id_fixed";
            else
                isBeId = true;

            let result = dom.querySelectorAll("#"+dom.id+selector);

            if (!isBeId)
                dom.removeAttribute("id");

            return result;
        } else
            return dom.querySelectorAll(selector);
    }
    /*
    * add listener to dom-element
    */
    addListener(dom, event, func) {
        if (!dom) {
            console.warn("cfJS (addListener): Element not found", dom, new Error().stack);
            return;
        }

        let headerClass = {
            connect: function () {
                dom.addEventListener(event, func, false);
            },
            disconnect: function () {
                if (dom.removeEventListener) {
                    dom.removeEventListener(event, func);
                } else if (dom.detachEvent) { // For IE 8 and earlier versions
                    dom.detachEvent(event, func);
                }
            }
        };

        headerClass.connect();
        headerClass.connect = null;

        return headerClass;
    }
    /*
    * Work with attribute
    */
    attr(dom,nameAttr,valueAttr) {
        if (!dom)
            return;

        if (!valueAttr && valueAttr!=="")
            return dom.getAttribute(nameAttr);
        else
            return dom.setAttribute(nameAttr,valueAttr);
    }
    /*
    * remove dom element attribute
    */
    removeAttr(dom,nameAttr) {
        return dom.removeAttribute(nameAttr);
    }

    /**
     * set wrong field error color
     * @param domName
     */
    appendValidationError(domName) {
        this.attr(this.byName(domName),"error","");
    }
    /*
    * set wrong field error color
    */
    removeValidationErrorFromForm(formDom) {
        let fields = formDom.querySelectorAll("input[error],select[error],textarea[error]"),
            that = this;

        for (let i=0; i<fields.length; i++) {
            that.removeAttr(fields[i],"error");
        }
    }
    /*
    * insert value to uri get param
    */
    insetUriGetParam(key,value) {
        var param = encodeURIComponent(key)+"="+encodeURIComponent(value);
        var _url = location.href;

        if (_url.split('?')[1] && (_url.split('?'+key+'=')[1] || _url.split('&'+key+'=')[1])) {
            var r = new RegExp("(&|\\?)"+key+"=[^\&]*");

            _url = _url.replace(r,"$1"+param);
        } else
            _url += (_url.split('?')[1] ? '&':'?') + param;

        history.pushState(null, null, _url);
    }
}

const cfJS = new cfJSClass();

export default cfJS;
